<template>
    <div class="sukikamo_menu" :class="id">
        <div class="button" :class="{clicked}" @click.prevent="clicked = true"><img src="../assets/images/sukikamo_menu.svg" alt="menu"></div>

        <div class="menu" v-if="clicked" @click.prevent="clicked = false">
            <div>
                <div @click="$modal.show(`rename_modal_${id}`)" class="menu_name">名前を変更する</div>
                <div @click="$modal.show(`delete_modal_${id}`)" class="menu_list">リストを削除する</div>
            </div>
        </div>

        <div class="modal_wrapper" @click.prevent>
            <modal :name="`rename_modal_${id}`"  :maxWidth="600" width="90%" :adaptive="true">
                <div class="modal_content">
                    <div class="modal_content_name">新しい名前を入力してください</div>
                    <input type="text" v-model="new_name">
                    <div class="buttons">
                        <button @click="renameList">変更する</button>
                    </div>
                </div>
            </modal>
            <modal :name="`delete_modal_${id}`"  :maxWidth="600" width="90%" :adaptive="true">
                <div class="modal_content">
                    <div>
                        選択したリストを削除します<br>
                        よろしいですか？
                    </div>
                    <div class="buttons">
                        <button @click="deleteList">削除する</button>
                        <button @click="$modal.hide(`delete_modal_${id}`)">キャンセル</button>
                    </div>
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    import { v4 as uuidv4 } from 'uuid'
    import Ajax from '../assets/js/Ajax'
    import { mapActions } from 'vuex'

    export default {
        name: "SukikamoListMenu",
        props: ['list_info'],
        data: () => ({
            id: `id_${uuidv4()}`,
            clicked: false,
            new_name: '',
            is_connecting: false
        }),
        mounted() {
            document.addEventListener('click', this.checkClickedThisElement);
            document.querySelectorAll('.sukikamo_menu .button').forEach(el => {
                el.addEventListener('click', this.checkClickedThisElement);
            });
        },
        destroyed() {
            document.removeEventListener('click', this.checkClickedThisElement);
            document.querySelectorAll('.sukikamo_menu .button').forEach(el => {
                el.removeEventListener('click', this.checkClickedThisElement);
            });
        },
        methods: {
            ...mapActions(["init"]),
            ...mapActions('my_page', ["reloadSukikamoList"]),
            checkClickedThisElement(e) {
                if (e.target.closest(`.${this.id} .button, .${this.id} .menu`)) return;
                this.clicked = false;
            },
            async renameList() {
                if ( this.is_connecting ) return;
                if ( !this.new_name ) return;

                this.is_connecting = true;
                await Ajax.updateSukikamoListName(this.list_info.id, this.new_name);
                await this.init();
                await this.reloadSukikamoList();
                this.is_connecting = false;
                this.$modal.hide(`rename_modal_${this.id}`)
            },
            async deleteList() {
                if ( this.is_connecting ) return;
                const list_id = this.list_info.id;

                this.is_connecting = true;
                await Ajax.removeSukikamoList(list_id);
                await this.init();
                await this.reloadSukikamoList();
                this.is_connecting = false;
            }
        }
    }
</script>

<style scoped lang="scss">
.sukikamo_menu{
    height: 1.5rem;
    width: 1.5rem;
    position: relative;
    .button{
        position: relative;
        display: flex;
        align-items: center;
        height: 100%;
        width: 100%;
        padding: 0.25rem;
        box-sizing: border-box;
        border-radius: 100%;

        vertical-align: middle;
        &:hover, &.clicked{
            box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
        }
        img{
            height: 100%;
            width: 100% !important;
        }
    }
    .menu{
        white-space: nowrap;
        position: absolute;
        bottom: 3px;
        width: 200px;
        /*left: -50%;*/
        left: -320%;
        transform: translate(-50%, 105%);
        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
        background-color: white;
        box-sizing: border-box;
        border-radius: 2px;
        color: #826E67;
        font-size: 13px;
        border: solid 1px #826E67;
    }
    .menu_name {
        border-bottom: dotted 2px #EADCDC;
    }
    .menu_name,
    .menu_list {
        padding: 5px 0 5px 15px;
    }
    .modal_wrapper{
        cursor: default;
        .modal_content{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
            .modal_content_name {
                margin: 0 0 20px;
            }
            input {
                width: 50%;
                height: 8%;
            }
            button {
                width: 120px;
                height: 40px;
                margin: 20px 10px 0;
                font-size: 13px;
                /*font-weight: bold;*/
                color: white;
                background-color: #ba8989;
                border: none;
                border-radius: 8px;
            }
            button:hover {
                cursor: pointer;
                opacity: 0.7;
            }
        }
    }

    @media screen and (max-width:639px) {
        .menu{
            width: 150px;
            left: -210%;
            z-index: 5;
        }
        .modal_wrapper{
            .modal_content{
                input {
                    width: 70%;
                }
            }
        }
    }
}
</style>
